import { useExercise } from '@entities/exercise-video/index.ts';
import type React from 'react';
import type { ExerciseVideo } from '@shared/types/exercises';
import { Card } from '@shared/ui';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import { useExerciseQuery } from '@src/api/api-hooks/exercises/useExerciseQuery.ts';
import Loader from '@src/library/components/common/Loader/index.ts';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  videoId?: number;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  onRedirect?: any;
  exerciseVideo?: ExerciseVideo;
}

export const ExerciseCard: React.FC<Props> = ({
  videoId,
  children,
  footer,
  onRedirect,
  exerciseVideo: exerciseVideoFromProps,
  ...props
}) => {
  const { exercise: exerciseFromRTK } = useExercise(videoId);
  const {
    data: exerciseFromQuery,
    isLoading,
    isError,
  } = useExerciseQuery({
    id:
      typeof exerciseFromRTK !== 'undefined' ||
      typeof exerciseVideoFromProps !== 'undefined' ||
      !videoId
        ? undefined
        : String(videoId),
  });

  const exercise = exerciseVideoFromProps || exerciseFromRTK || exerciseFromQuery;

  if (isError) {
    return <>Видео не найдено</>;
  }

  return (
    <div className={st.wrapper} {...props}>
      {isLoading ? (
        <Loader disableMargin inCenter />
      ) : (
        <>
          <Card className={st.card}>
            <div className={st.card__image}>
              <ImageWithSkeleton
                src={exercise?.screenshot_url}
                alt={exercise?.title}
                className={st.img}
              />
            </div>
            <div className={st.card__title}>
              <h3>{exercise?.title}</h3>
            </div>
            {footer && footer}
          </Card>
          <div className={st.card__children}>{children}</div>
        </>
      )}
    </div>
  );
};
